import type {
  SharedDataSetEventHandler,
  SharedDataSetEventName,
} from './sharedDataSet';
import type { FrameSeq, ProjectID, TaskID } from './type';

export const genKey = (param: {
  frameSeq: FrameSeq;
  projectID: ProjectID;
  taskID: TaskID;
}) => `${param.projectID}_${param.taskID}_${param.frameSeq}` as const;

export const isValidEventPostMessage = (
  data: MessageEvent['data'],
): data is {
  payload: Parameters<SharedDataSetEventHandler>[1];
  type: Parameters<SharedDataSetEventHandler>[0];
} => {
  switch (data.type as SharedDataSetEventName) {
    case 'changeCameraCalibrationConfigMap':
    case 'changeCurrentFrame':
    case 'changeSelectedImageIndex':
    case 'changeSelectedLabelingBoxIdList':
    case 'changeSelectedTask':
    case 'focusBox':
      return true;
    default:
      return false;
  }
};
